import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { logementAPI } from '../../service/api';
import { FiMapPin, FiHome, FiHeart, FiTrash2 } from 'react-icons/fi';
import { resolveUploadUrl } from '../../config/config';
import { toast } from '../../service/swal';
import useAutoRefresh from '../../hooks/useAutoRefresh';

const typeLabels = { studio: 'Studio', appartement: 'Appartement', maison: 'Maison', chambre: 'Chambre' };

export default function FavoritesPage() {
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchFavorites = async (skipLoading = false) => {
    if (!skipLoading) setLoading(true);
    try {
      const res = await logementAPI.getMyFavorites();
      setFavorites(res.data.data || []);
    } catch (err) { console.error(err); }
    finally { if (!skipLoading) setLoading(false); }
  };

  useEffect(() => { fetchFavorites(); }, []);
  useAutoRefresh(() => fetchFavorites(true), 30000);

  const handleRemove = async (propertyId) => {
    try {
      await logementAPI.removeFavorite(propertyId);
      setFavorites(prev => prev.filter(p => p.id !== propertyId));
      toast('success', 'Retiré des favoris');
    } catch (err) { toast('error', 'Erreur'); }
  };

  return (
    <div className="page-container py-8">
      <div className="mb-8">
        <h1 className="font-serif text-3xl font-bold tracking-tight" style={{ color: '#0A192F' }}>Mes favoris</h1>
        <p className="text-sm mt-1" style={{ color: '#7A828A' }}>
          {favorites.length} logement{favorites.length > 1 ? 's' : ''} enregistré{favorites.length > 1 ? 's' : ''}
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <div className="animate-spin rounded-full h-8 w-8 border-2" style={{ borderColor: '#C59B6C', borderTopColor: 'transparent' }} />
        </div>
      ) : favorites.length === 0 ? (
        <div className="text-center py-20">
          <FiHeart className="w-16 h-16 mx-auto mb-4" style={{ color: '#E5E5E0' }} />
          <p style={{ color: '#7A828A' }}>Aucun favori pour le moment</p>
          <Link to="/logements" className="btn-primary-root mt-4 inline-block">Parcourir les logements</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {favorites.map((logement) => (
            <div key={logement.id} className="card-root overflow-hidden hover:shadow-md transition-shadow">
              <Link to={`/logements/${logement.id}`}>
                <div className="h-48 flex items-center justify-center overflow-hidden" style={{ backgroundColor: '#E5E5E0' }}>
                  {logement.images && logement.images.length > 0 ? (
                    <img src={resolveUploadUrl(logement.images[0])} alt={logement.titre} className="w-full h-full object-cover" />
                  ) : (
                    <FiHome className="w-12 h-12" style={{ color: '#88929B' }} />
                  )}
                </div>
              </Link>
              <div className="p-5">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[11px] font-bold tracking-widest uppercase px-3 py-1 border-2"
                    style={{ color: '#0A192F', borderColor: '#0A192F' }}>{typeLabels[logement.type] || logement.type}</span>
                  <span className="font-bold text-lg" style={{ color: '#C59B6C' }}>{Number(logement.prix).toLocaleString()} $</span>
                </div>
                <Link to={`/logements/${logement.id}`}>
                  <h3 className="font-serif font-bold text-base mb-1" style={{ color: '#0A192F' }}>{logement.titre}</h3>
                </Link>
                <p className="text-xs flex items-center gap-1" style={{ color: '#7A828A' }}>
                  <FiMapPin className="w-3 h-3" /> {logement.adresse}
                </p>
                <button onClick={() => handleRemove(logement.id)}
                  className="mt-3 flex items-center gap-1 text-xs font-semibold uppercase tracking-wider"
                  style={{ color: '#C62828' }}>
                  <FiTrash2 className="w-3 h-3" /> Retirer des favoris
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}